import React, { useCallback, useEffect, useState } from 'react';
import { AppBar, Tabs, Tab, IconButton, Box } from '@mui/material';
import { ArrowLeft } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { Download } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from 'src/components/Breadcrumb';
import TabPanel from 'src/components/TabPanel/TabPanel';
import { distributorDetailTabsIndex } from 'src/utils/constants/distributors';
import { useNavigate, useParams } from 'react-router-dom';
import { selectDistributorDetail } from 'src/store/selectors/distributorSelectors';
import ContractStatus from 'src/utils/constants/contracts';
import MenuButton from 'src/components/MenuButton/MenuButton';
import { downloadDistributorClientsExcel } from 'src/store/actions/distributorActions';
import BrandsAndModelsView from 'src/views/userViews/UserDistributorView/BrandsAndModelsView';
import GeneralView from './General';
import ContactsView from './Contacts';
import CatalogsView from './Catalogs';
import AgentDetailView from './AgentsDetail/AgentDetail';
import ParameterDetailView from './Parameter';
import {
  DownloadDistributorClientsOptions,
  selectDownloadDistributorClientsOptions
} from './helper/downloadDistributorClientsOptions';

const distributorDetailMenuList = [
  {
    value: distributorDetailTabsIndex.GENERAL,
    label: 'COMMON.GENERAL'
  },
  {
    value: distributorDetailTabsIndex.CONTACTS,
    label: 'COMMON.CONTACTS'
  },
  {
    value: distributorDetailTabsIndex.CATALOG,
    label: 'COMMON.CATALOG'
  },
  {
    value: distributorDetailTabsIndex.BRANDS_AND_MODELS,
    label: 'COMMON.BRANDS_AND_MODELS'
  },
  {
    value: distributorDetailTabsIndex.PROFILES,
    label: 'COMMON.PROFILES'
  },
  {
    value: distributorDetailTabsIndex.PARAMETERS,
    label: 'NAVIGATION.PARAMETERS'
  }
];

const DistributorTabs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id, tab } = useParams();
  const distributor = useSelector(selectDistributorDetail);

  const [value, setValue] = useState(false);

  const handleChange = useCallback(
    (_, newValue) => {
      setValue(newValue);
      navigate(`/distributors/business/${id}/${newValue}`);
    },
    [setValue]
  );

  useEffect(() => {
    if (id && !tab) {
      setValue(distributorDetailTabsIndex.GENERAL);
    }
    if (tab) {
      if (Object.values(distributorDetailTabsIndex).includes(tab)) {
        setValue(tab);
      } else {
        navigate(`/buisiness/distributors/${id}`);
      }
    }
  }, [id, tab]);

  const handleDownloadClients = useCallback(
    option => {
      if (!id) {
        return;
      }

      if (
        option ===
        DownloadDistributorClientsOptions.CLIENTS_WITH_ACTIVE_CONTRACTS
      ) {
        dispatch(
          downloadDistributorClientsExcel(id, ContractStatus.IN_PROGRESS)
        );
        return;
      }

      if (
        option ===
        DownloadDistributorClientsOptions.CLIENTS_WITH_ENDED_CONTRACTS
      ) {
        dispatch(downloadDistributorClientsExcel(id, ContractStatus.ENDED));
        return;
      }

      if (option === DownloadDistributorClientsOptions.ALL_CLIENTS) {
        dispatch(downloadDistributorClientsExcel(id));
      }
    },
    [dispatch, id]
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Breadcrumb doNotRedirectIndexList={[0]} />
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center'
          }}
        >
          <IconButton onClick={() => navigate(-1)} color="primary" component="span">
            <ArrowLeft />
          </IconButton>
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            value={value}
            onChange={handleChange}
          >
            {distributorDetailMenuList.map(item => (
              <Tab key={item.value} label={t(item.label)} value={item.value} />
            ))}
          </Tabs>
        </Box>
        <MenuButton
          icon={<Download />}
          options={selectDownloadDistributorClientsOptions()}
          handleClickOption={handleDownloadClients}
        />
      </AppBar>
      <TabPanel value={value} index={distributorDetailTabsIndex.GENERAL}>
        <GeneralView distributor={distributor} />
      </TabPanel>
      <TabPanel value={value} index={distributorDetailTabsIndex.CONTACTS}>
        <ContactsView />
      </TabPanel>
      <TabPanel value={value} index={distributorDetailTabsIndex.CATALOG}>
        <CatalogsView />
      </TabPanel>
      {/* This is planned to be remove in the future */}
      <TabPanel
        value={value}
        index={distributorDetailTabsIndex.BRANDS_AND_MODELS}
      >
        <BrandsAndModelsView />
      </TabPanel>
      <TabPanel value={value} index={distributorDetailTabsIndex.PROFILES}>
        <AgentDetailView />
      </TabPanel>
      <TabPanel value={value} index={distributorDetailTabsIndex.PARAMETERS}>
        <ParameterDetailView />
      </TabPanel>
    </Box>
  );
};

export default DistributorTabs;
